// extracted by mini-css-extract-plugin
export default {"figure":"rNtSXY","container":"J3IyKr","meat":"jPG7j0","bull":"A5Pk8j"};